import React from 'react';

import {Table} from 'spectra-logic-ui/components';

import {Account, LifecycleV2} from '@/types';

type Props = {
  account: Account;
  lifecycles: LifecycleV2[];
}

const PropertiesDetails = ({account, lifecycles}: Props) => {
  let lifecycle = '';
  if (account.defaultLifecycleId) {
    const lc = lifecycles.find((l) => l.id === account.defaultLifecycleId);
    if (lc) {
      lifecycle = lc.name;
    }
  }

  const accountProps = [
    {key: 'ID', value: account.id},
    {key: 'Description', value: account.description},
    {key: 'Email', value: account.email},
    {key: 'Type', value: account.local ? 'Local' : 'AWS'},
    {key: 'Canonical ID', value: account.canonicalId},
    {key: 'Connection Limit', value: account.connectionLimit !== undefined ? account.connectionLimit + '%' : ''},
    {key: 'Default Lifecycle', value: lifecycle ? lifecycle : <i>Global Default</i>},
  ];
  if (!account.local) {
    accountProps.push({key: 'Role ARN', value: account.roleArn});
    accountProps.push({key: 'External ID', value: account.externalId});
  }
  accountProps.push({key: 'Status', value: account.inactive ? 'Inactive' : 'Active'});

  return (
    <Table>
      <Table.Body>
        {accountProps.map((kv) => (
          <Table.Row key={kv.key}>
            <Table.Cell>{kv.key}</Table.Cell>
            <Table.Cell>{kv.value}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default PropertiesDetails;
